// src/components/resources/tools/generators/ReviewMockup/appstore-reviews.ts
//
// Pure (hook-free) helpers harvested verbatim from the former AppStoreReview
// render body (A11b decomposition). Kept here so the App Store list assembly
// and histogram normalization are testable in isolation from the React island.

import type { AppStoreReviewItem, ReviewConfig } from './types'

/**
 * Normalized max bar weight for the star-distribution histogram. Bars are
 * normalized to this value; the `, 1` floor guards against an all-zero
 * distribution dividing by zero.
 */
export function appStoreMaxBar(distribution: readonly number[]): number {
  return Math.max(...distribution, 1)
}

/**
 * Assemble the stacked App Store review list: the primary review (driven by the
 * shared review fields so the existing headline / body / rating / reviewer /
 * date controls keep working) followed by the configured additional reviews.
 */
export function buildAppStoreReviews(config: ReviewConfig): AppStoreReviewItem[] {
  const app = config.appStore
  // Primary review is driven by the shared review fields so the existing
  // headline / body / rating / reviewer / date controls keep working.
  const primaryReview: AppStoreReviewItem = {
    title: config.reviewTitle,
    body: config.reviewText,
    rating: config.rating,
    reviewerName: config.reviewerName,
    date: config.date,
  }
  return [primaryReview, ...app.additionalReviews]
}
